module.exports = __webpack_public_path__ + "img/5.cf7e96df.jpg";